module.exports = __webpack_public_path__ + "static/img/action-icon5.a8a129c4.png";